import { useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import BackButton from 'components/backButton'
import { Button } from 'components/common'
import { FreshCategoryForm } from 'components/freshCategory'
import { createFreshCategory } from 'utils/api/freshCategoryApi'
import { PAGE_FRESH_CATEGORY } from 'utils/constants'
import { handleError } from 'utils/helpers/handleError'
import {
  FreshCategoryFormFields,
  freshCategorySchema,
} from 'utils/schema/freshCategorySchema'

const CreateFreshCategory = () => {
  const navigate = useNavigate()
  const [isUploading, setIsUploading] = useState<boolean>(false)

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<FreshCategoryFormFields>({
    resolver: yupResolver(freshCategorySchema),
    defaultValues: { isActive: true, image: '' },
  })

  const handleCreate = async (data: FreshCategoryFormFields) => {
    const toastId = toast.loading('Creating category...', {
      duration: Infinity,
    })
    try {
      await createFreshCategory(data)
      toast.success('Category created successfully', {
        id: toastId,
        duration: 3000,
      })
      navigate(PAGE_FRESH_CATEGORY.path)
    } catch (error) {
      handleError(
        error,
        toastId,
        { default: 'Failed to create category. Please try again.' },
        5000,
      )
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Add Fresh Category</title>
      </Helmet>

      <BackButton />

      <form onSubmit={handleSubmit(handleCreate)}>
        <FreshCategoryForm
          register={register}
          control={control}
          setValue={setValue}
          errors={errors}
          onUploadingChange={setIsUploading}
        />

        <Button
          buttonText="Create Category"
          className="mt-7 w-44"
          disabled={isUploading}
        />
      </form>
    </>
  )
}

export default CreateFreshCategory
